import { resolveScheduleStepLabel } from "@/features/entries/services/timingLabelDerivation";
import { DEFAULT_LOCALE, type SupportedLocale } from "@patient-watch/i18n";
import type { DueEntryT } from "@patient-watch/types";

/** Label for the schedule step this entry is for (e.g. Week 6, Baseline). */
export function entryScheduleLabelFromNextEntry(
    nextEntry?: DueEntryT | null,
    locale: SupportedLocale = DEFAULT_LOCALE
): string | null {
    if (!nextEntry) return null;
    return resolveScheduleStepLabel(
        {
            label: nextEntry.label,
            interval: nextEntry.interval,
            time_unit: nextEntry.time_unit,
            schedule_index: nextEntry.schedule_index,
        },
        { locale }
    );
}
